import { render, staticRenderFns } from "./DeleteUserDialog.vue?vue&type=template&id=0d3a0665&scoped=true&"
import script from "./DeleteUserDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a0665",
  null
  
)

export default component.exports